/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Twda_Failed_InternalInputs */



/**
* | output |
* | --- |
* | "an unexpected error" |
*
* @param {Twda_Failed_InternalInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const twda_failed_internal = /** @type {((inputs?: Twda_Failed_InternalInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Twda_Failed_InternalInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("une erreur inattendue")
	if (locale === "es") return /** @type {LocalizedString} */ ("un error inesperado")
	if (locale === "pt") return /** @type {LocalizedString} */ ("um erro inesperado")
	if (locale === "it") return /** @type {LocalizedString} */ ("un errore imprevisto")
	return /** @type {LocalizedString} */ ("an unexpected error")
});